/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';

type ColumnKeys =
  | 'name'
  | 'database_name'
  | 'country_of_origin'
  | 'status_flag'
  | 'hit_count'
  | 'match_probability';

interface ISingleResultCol {
  isSelectedItems?: boolean;
  handleCheckboxClick?: any;
  hideCountry?: boolean;
  sortData: (key: string) => void;
  sortConfig: { key: string, direction: string };
  disabled?: boolean;
}
const ReviewQColumns: React.FC<ISingleResultCol> = ({ isSelectedItems, handleCheckboxClick, hideCountry, sortData, sortConfig, disabled = false }) => {
  const [ svgIcons, setSvgIcons ] = useState<Record<ColumnKeys, JSX.Element>>({
    name: <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M7.99967 12.6666V3.33331M7.99967 3.33331L3.33301 7.99998M7.99967 3.33331L12.6663 7.99998'
        stroke='var(--card-text)'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>,
    status_flag: <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M7.99967 12.6666V3.33331M7.99967 3.33331L3.33301 7.99998M7.99967 3.33331L12.6663 7.99998'
        stroke='var(--card-text)'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>,
    database_name: <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M7.99967 12.6666V3.33331M7.99967 3.33331L3.33301 7.99998M7.99967 3.33331L12.6663 7.99998'
        stroke='var(--card-text)'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>,
    country_of_origin: <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M7.99967 12.6666V3.33331M7.99967 3.33331L3.33301 7.99998M7.99967 3.33331L12.6663 7.99998'
        stroke='var(--card-text)'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>,
    match_probability: <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M7.99967 12.6666V3.33331M7.99967 3.33331L3.33301 7.99998M7.99967 3.33331L12.6663 7.99998'
        stroke='var(--card-text)'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>,
    hit_count: <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M7.99967 12.6666V3.33331M7.99967 3.33331L3.33301 7.99998M7.99967 3.33331L12.6663 7.99998'
        stroke='var(--card-text)'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>,
  });

  useEffect(() => {
    const newSvgIcons = { ...svgIcons };

    // Update the SVG icons based on the sorting state
    (Object.keys(newSvgIcons) as ColumnKeys[]).forEach((column) => { // Cast keys to ColumnKeys[]
      if (column === sortConfig.key) {
        newSvgIcons[column] = sortConfig.direction === 'asc' ? (
          <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
            <path
              d='M7.99967 12.6666V3.33331M7.99967 3.33331L3.33301 7.99998M7.99967 3.33331L12.6663 7.99998'
              stroke='var(--card-text)'
              strokeWidth='1.33333'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        ) : (
          <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
            <path
              d='M7.99967 3.33331V12.6666M7.99967 12.6666L3.33301 7.99998M7.99967 12.6666L12.6663 7.99998'
              stroke='var(--card-text)'
              strokeWidth='1.33333'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        );
      } else {
        // Reset the icon to the default state
        newSvgIcons[column] = (
          <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
            <path
              d='M7.99967 12.6666V3.33331M7.99967 3.33331L3.33301 7.99998M7.99967 3.33331L12.6663 7.99998'
              stroke='var(--card-text)'
              strokeWidth='1.33333'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        );
      }
    });

    setSvgIcons(newSvgIcons);
  }, [ sortConfig ]);

  return (
    <div className='screening-results-columns' >
      <div className='screening-table-placeholder-column' style={{ borderTopLeftRadius: 'var(--radius-xl, 12px)', padding: '12px', cursor: 'pointer' }}>
        <div
          className='screening-results-row-default-cell-inner'
          onClick={() => {
            if (!disabled) {
              handleCheckboxClick();
            }
          }}
        >
          {isSelectedItems ? (
            <div className='full-list-filters-cont-row-icon-item'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='12'
                height='12'
                viewBox='0 0 12 12'
                fill='none'
              >
                <path
                  d='M10 3L4.5 8.5L2 6'
                  stroke='var(--text-primary)'
                  strokeWidth='1.6666'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </div>
          ) : (
            <div className='full-list-filters-cont-row-icon-item-unselected'></div>
          )}
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner' onClick={() => !disabled && sortData('name')}>
          <div className='screening-table-column-text'>
          Name {svgIcons.name}
          </div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner' onClick={() => !disabled && sortData('database_name')}>
          <div className='screening-table-column-text'>
          Database Name {svgIcons.database_name}
          </div>
        </div>
      </div>
      {!hideCountry && (
        <div className='screening-table-title-column'>
          <div className='screening-table-title-column-inner' onClick={() => !disabled && sortData('country_of_origin')}>
            <div className='screening-table-column-text'>
            Country {svgIcons.country_of_origin}
            </div>
          </div>
        </div>
      )}
      {/* <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>
          Risk Level

          </div>
        </div>
      </div> */}
      <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner' onClick={() => !disabled && sortData('status_flag')}>
          <div className='screening-table-column-text'>
          Status {svgIcons.status_flag}
          </div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner' onClick={() => !disabled && sortData('match_probability')}>
          <div className='screening-table-column-text'>
         Assigned Risk {svgIcons.match_probability}
          </div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>
         Lenses
          </div>
        </div>
      </div>
      <div className='screening-table-title-column' style={{ justifyContent: 'center' }}>
        <div className='screening-table-title-column-inner' onClick={() => !disabled && sortData('hit_count')}>
          <div className='screening-table-column-text'>
         Matched Hits {svgIcons.hit_count}
          </div>
        </div>
      </div>
      <div className='screening-table-placeholder-column' style={{ borderTopRightRadius: 'var(--radius-xl, 12px)', width: '56px' }}>
        <div
          className='screening-results-row-default-cell-inner'
        >
        </div>
      </div>
    </div>
  );
};

export default ReviewQColumns;
